<template>
  <div>
    <v-autocomplete
      v-model="search"
      :items="companies.data"
      item-text="nome"
      outlined
      dense
      clearable
      :label="label"
      return-object
      @change="saveSelected"
      autofocus
      :loading="loading"
      :disabled="loading"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      search: {},
      loading: true
    };
  },
  async mounted() {
    await this.loadCompanies().catch(error => {
      this.$swal("Oops...", error.message, "error");
    });
    this.loading = false;
  },
  computed: {
    ...mapState("company", ["companies"]),
    ...mapGetters({
      label: "forms/getItemLabel",
      text: "forms/getItemText"
    })
  },
  methods: {
    ...mapActions("company", ["loadCompanies"]),
    ...mapMutations({
      setModel: "forms/setModelCompany"
    }),
    saveSelected() {
      this.setModel(this.search);
    }
  }
};
</script>
